import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import usePermissions from '~hooks/usePermissions';
import { IEntityComponentProps } from '~interfaces/props';
import MediaLibraryController from '~modules/media-library/controller/MediaLibraryController';
import { onOpenContributionWizard } from '~modules/media-library/controller/thunks/contribute';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import { selectConfigIsMediaLibraryMaintenance } from '~store/selectors';

export default function ModuleContribute({ data, editing, className }: IEntityComponentProps) {
  const isMediaLibraryMaintenance = useAppSelector(selectConfigIsMediaLibraryMaintenance);
  // const { resultAssetIds, resultCount, onLoadMore, onRefetch } = useMediaLibrarySearchResult();
  const { hasPassMaintenanceModePermission } = usePermissions();

  const dispatch = useDispatch();

  // labels
  const { hlContribute, msgMediaLibraryMaintenance } = useLabels(['hlContribute', 'msgMediaLibraryMaintenance']);

  if (isMediaLibraryMaintenance && !hasPassMaintenanceModePermission) {
    return (
      <div className="px-5 py-4">
        <h2>{hlContribute}</h2>
        <p dangerouslySetInnerHTML={{ __html: msgMediaLibraryMaintenance }}></p>
      </div>
    );
  }

  // Do not render if there is no data!
  if (!data) {
    return null;
  }

  // ClassName generation
  const clsModule = clsx({ ...className.module });
  const clsContainer = clsx({ ...className.container });

  // derived values
  const realm = 'contribute_library';

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      {editing ? (
        <div className={clsContainer}>
          <div className="row c-module__header">
            <div className="col u-margin-bottom-md container px-0">
              <div className="row">
                <h2>{hlContribute}</h2>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="px-3">
            <div className="mx-auto max-w-screen-xl">
              <button
                className="ml--button ml--button-default appearance-none outline-none overflow-hidden inline-flex m-0 text-black font-sans leading-none rounded items-center overflow-hidden select-none transition whitespace-nowrap border-silver ml--select-button ml--filter-button  hover:border-black cursor-pointer border border-solid py-2 px-3 bg-white h-8 text-sm"
                onClick={() => dispatch(onOpenContributionWizard({ id: null, contributionMode: 'new' }))}
              >
                Start new contribution
              </button>
            </div>
          </div>

          <article className="block relative min-h-screen w-full">
            <MediaLibraryController realm={realm} />
          </article>
        </div>
      )}
    </div>
  );
}
